export const TOGGLE_FILE_UPLOAD_PRO = 'data-room/upload/progress';
export const UPLOAD_FILE_STACK = 'data-room/upload/files';
export const UPLOAD_AFTER_FILE_STACK = 'data-room/upload/files/status';
export const CLEAN_FILES_STACK = 'data-room/clean/files/stack';
export const TOGGLE_UPLOAD_STATS_BAR = 'data-room/upload/files/stats';
